import { useContext } from "react";
import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";
import { navigateToCrossUiRoute } from "@usas/ui-web/utils/FormatCrossUiRoute";
import { AccountCreationReturnContext } from "./AccountCreationReturnContext";

export const useAccountCreationReturnButton = () => {
  const navigate = useNavigate();
  const [accountCreationReturnState, setAccountCreationReturnState] = useContext(AccountCreationReturnContext);
  const { resetAccountCreationState } = useAccountCreationData();

  const onReturnToClicked = (e) => {
    e?.preventDefault();

    if (accountCreationReturnState.returnProject && accountCreationReturnState.returnPath) {
      if (accountCreationReturnState.returnProject === 'data-hub-ui') { //TODO hardcoded
        window.location.href = import.meta.env.VITE_DHY_BASE_URL;
        return;
      }

      navigateToCrossUiRoute(accountCreationReturnState.returnProject, accountCreationReturnState.returnPath, navigate);
    } else {
      resetAccountCreationState();
    }
  }

  return {
    accountCreationReturnState,
    setAccountCreationReturnState,
    onReturnToClicked
  };
}